import { render, staticRenderFns } from "./FUniswapSwap.vue?vue&type=template&id=05f86d28&"
import script from "./FUniswapSwap.vue?vue&type=script&lang=js&"
export * from "./FUniswapSwap.vue?vue&type=script&lang=js&"
import style0 from "./FUniswapSwap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports